import { Injectable } from '@angular/core';
//import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { HttpClient} from '@angular/common/http'; 

@Injectable()
export class ApplAgeService {

  constructor(private http: HttpClient, private _http: HttpClient) { }
  
	ageConfigStore( formJSON2 : any, PID: any, AID: any, ID:any){
	    let formJSON1 = JSON.stringify(formJSON2);
		let PID1 = JSON.stringify(PID);
		let AID1 = JSON.stringify(AID);
		let ID1 = JSON.stringify(ID);
		return this._http.post(environment.appUrl + "age", { formJSON: formJSON1, PID: PID1 ,AID: AID1,ID: ID1})
		.map(result => {			
			return result;
		});
	}
	 
	getAgeCofigDetails(PID: any, AID: any){
		let PID1 = JSON.stringify(PID);
		let AID1 = JSON.stringify(AID);
		return this._http.get(environment.appUrl + "age",{params:{PID: PID1 ,AID: AID1}})
		.map(result => {			
			return result;
		});
   
   }

   removeAgeConfig(PID: any, AID: any) {
	let PID1 = JSON.stringify(PID);
	let AID1 = JSON.stringify(AID);
	return this._http.delete(environment.appUrl + "age",{params:{PID: PID1 ,AID: AID1}})
	.map(result => {			
		return result;
	});
   }

}
